<template>
    <h5 class="d-flex bold mb-3 mt-1">
        Ticket Summary

        <span v-if="tag" class="ml-auto">Dummy Vehicle</span>
    </h5>
</template>

<script>
    export default {
        props: {
            tag: Boolean,
        },
    }
</script>




// WEBPACK FOOTER //
// SummaryHeader.vue?7eba77ce